// extracted by mini-css-extract-plugin
export default {"quick-response":"_quick_reply-quick-response-d14031","quick-evaluate":"_quick_reply-quick-evaluate-c1e77c","evaluation-widget":"_quick_reply-evaluation-widget-5066d2"};